import { render, staticRenderFns } from "./ChemUCI1LDQ2S2Q3.vue?vue&type=template&id=48ed8d0f&scoped=true&"
import script from "./ChemUCI1LDQ2S2Q3.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LDQ2S2Q3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ed8d0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VForm,VImg,VRadio,VRadioGroup})
